/**
 * features/admin/useUsers.ts
 * Live subscription to the users allowlist.
 */
import { useEffect, useState } from 'react';
import { collection, onSnapshot, orderBy, query } from 'firebase/firestore';
import { db } from '@/lib/firebase';
import { COLLECTIONS, type AppUser } from '@/types';

export interface UserRow extends AppUser {
  id: string;
}

export function useUsers() {
  const [users, setUsers] = useState<UserRow[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const q = query(collection(db, COLLECTIONS.users), orderBy('email', 'asc'));
    return onSnapshot(
      q,
      (snap) => {
        setUsers(snap.docs.map((d) => ({ id: d.id, ...(d.data() as AppUser) })));
        setLoading(false);
      },
      () => setLoading(false),
    );
  }, []);

  return { users, loading };
}
